import {CustomerContext} from "@/context/CustomerContext";
import {I18nContext} from "@/context/I18nContext";
import configFile from "../../../public/config.json";

/*
* Generates the url to preview a content page on the SMA
 */
function generateContentPagePreviewUrl(content_page_id: string, expect_hidden_content: boolean = false): string {
    const language: string = I18nContext.getDefaultApiLanguageKey();
    const mainDomain: string = CustomerContext.hasMainDomain()
        ? 'https://' + CustomerContext.getMainDomain()
        : configFile.contentProviderContentPreviewUrl;

    let parameters = '' as string;
    parameters += (expect_hidden_content) ? '?expect_hidden_content=true' : '?expect_hidden_content=false';

    return `${mainDomain}/${language}/_dp/content-page/${content_page_id}/preview${parameters}`
}

function generateContentPagePriceCardPreviewUrl(content_page_id: string, pageSizeCode: string = 'A5'): string {
    const language: string = I18nContext.getDefaultApiLanguageKey();
    const mainDomain: string = CustomerContext.hasMainDomain()
        ? 'https://' + CustomerContext.getMainDomain()
        : configFile.contentProviderContentPreviewUrl;

    let parameters = '' as string;
    parameters += '?page-size-code=' + pageSizeCode;

    return `${mainDomain}/${language}/_dp/content-page/${content_page_id}/price-card.pdf${parameters}`
}

/*
* Generates the url to preview a product filter on the SMA
 */
function generateProductFilterPreviewUrl(product_filter_code: string): string | null {
    const language: string = I18nContext.getDefaultApiLanguageKey();
    const mainDomain: string | null = CustomerContext.hasMainDomain()
        ? 'https://' + CustomerContext.getMainDomain()
        : null;

    if (mainDomain && language === 'nl') {
        // todo implement this url when available in SMA (remove if for language as well)
        // return `${mainDomain}/${language}/_dp/product_filter/${product_filter_code}/preview`;
        return `${mainDomain}/${language}/apotheek/bc/${product_filter_code}`;
    }

    return null;
}

/*
* Generates the shareable url to preview a content preview on the SMA.
* Returns null when the customer has no main domain: a content preview is resolved by the
* customer's own website, so there is no meaningful fallback host.
 */
function generateContentPreviewUrl(preview_key: string): string | null {
    if (!CustomerContext.hasMainDomain()) {
        return null;
    }

    const language: string = I18nContext.getDefaultLanguage();
    const mainDomain: string = 'https://' + CustomerContext.getMainDomain();

    return `${mainDomain}/${language}?preview_key=${encodeURIComponent(preview_key)}`;
}

/*
* Generates the shareable url to preview a custom css preview content block on the SMA.
* Returns null when the customer has no main domain, for the same reason as
* generateContentPreviewUrl.
 */
function generateCustomCssPreviewUrl(content_block_id: string): string | null {
    if (!CustomerContext.hasMainDomain()) {
        return null;
    }

    const language: string = I18nContext.getDefaultLanguage();
    const mainDomain: string = 'https://' + CustomerContext.getMainDomain();

    return `${mainDomain}/${language}?custom_css_preview_key=${encodeURIComponent(content_block_id)}`;
}

export {
    generateContentPagePreviewUrl,
    generateProductFilterPreviewUrl,
    generateContentPagePriceCardPreviewUrl,
    generateContentPreviewUrl,
    generateCustomCssPreviewUrl,
}
